import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const ProductPage = lazy(() => import("../pages/product/page"));
const CartPage = lazy(() => import("../pages/cart/page"));
const CheckoutPage = lazy(() => import("../pages/checkout/page"));
const AllProductsPage = lazy(() => import("../pages/products/page"));
const BrandsPage = lazy(() => import("../pages/brands/page"));
const CategoriesPage = lazy(() => import("../pages/categories/page"));
const MyOrdersPage = lazy(() => import("../pages/account/orders/page"));
const OrderDetailPage = lazy(() => import("../pages/account/orders/detail/page"));
const AdminOrdersPage = lazy(() => import("../pages/admin/orders/page"));
const AdminOrderDetailPage = lazy(() => import("../pages/admin/orders/detail/page"));
const LoginPage = lazy(() => import("../pages/login/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const ServerError = lazy(() => import("../pages/ServerError"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/products",
    element: <AllProductsPage />,
  },
  {
    path: "/brands",
    element: <BrandsPage />,
  },
  {
    path: "/categories",
    element: <CategoriesPage />,
  },
  {
    path: "/product/:id",
    element: <ProductPage />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/account/orders",
    element: <MyOrdersPage />,
  },
  {
    path: "/account/orders/:id",
    element: <OrderDetailPage />,
  },
  {
    path: "/admin/orders",
    element: <AdminOrdersPage />,
  },
  {
    path: "/admin/orders/:id",
    element: <AdminOrderDetailPage />,
  },
  {
    path: "/500",
    element: <ServerError />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
